import axios from 'axios';
import { notifications } from '../store/notifications';

// Fonction utilitaire pour gérer la déconnexion
const handleLogout = () => {
    localStorage.removeItem('discord_token');
    localStorage.removeItem('discord_user');
    localStorage.removeItem('subscription_info');
    localStorage.removeItem('impersonated_user');
    window.location.href = '/';
};

// Liste des endpoints qui ne nécessitent pas d'authentification
const publicEndpoints = [
    '/subscriptions/health'
];

// API instance qui sera exportée
const api = axios.create({
    // Prefer the configured API URL when provided (dev + prod). Fallback to devServer proxy.
    baseURL: process.env.VUE_APP_API_URL
        ? `${process.env.VUE_APP_API_URL}/api`
        : '/api',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request interceptor
api.interceptors.request.use(
    config => {
        const token = localStorage.getItem('discord_token');
        // Only add token if endpoint is not public
        if (token && !publicEndpoints.includes(config.url)) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor
api.interceptors.response.use(
    response => response,
    error => {
        // Ne pas afficher de notifications d'erreur sur les pages d'authentification
        const authPages = ['/', '/register', '/callback', '/twitch-callback'];
        if (authPages.includes(window.location.pathname)) {
            return Promise.reject(error);
        }

        if (error.response) {
            // Gérer les erreurs d'authentification (401 uniquement)
            if (error.response.status === 401) {
                // Rediriger vers la page de connexion seulement pour les erreurs d'authentification
                handleLogout();
                return Promise.reject(error);
            }
            
            // Pour les autres erreurs (403, 500, etc.), afficher une notification mais ne pas déconnecter
            // Log subscription errors for debugging
            if (error.config.url.includes('/subscriptions')) {
                console.error('Erreur de requête subscription:', error.response.status, error.response.data);
            }

            // Gérer les autres erreurs avec un code de réponse
            // Pas de notification pour les erreurs 403 car elles sont gérées individuellement
            if (error.response.status !== 403) {
                notifications.add({
                    type: 'error',
                    message: error.response.data?.message || 'Une erreur est survenue',
                    timeout: 5000
                });
            }
        } else if (error.request) {
            // La requête a été faite mais aucune réponse n'a été reçue
            notifications.add({
                type: 'error',
                message: 'Impossible de contacter le serveur',
                timeout: 5000
            });
        } else {
            // Une erreur s'est produite lors de la configuration de la requête
            notifications.add({
                type: 'error',
                message: 'Erreur lors de la configuration de la requête',
                timeout: 5000
            });
        }

        return Promise.reject(error);
    }
);

export { api };
